import { PersonInterface } from ".";
import { UserHelper as BaseUserHelper } from "../appBase/helpers"
import { Permissions } from "../helpers/Permissions";
export class UserHelper extends BaseUserHelper {
  static isHost() {
    return UserHelper.checkAccess(Permissions.contentApi.streamingServices.edit)
    || UserHelper.checkAccess(Permissions.contentApi.chat.host)
  }
  static isGuest: boolean = false;
  static person: PersonInterface;
}
